<template>
  <div class="textarea-editor">
    <div
      ref="textarea"
      class="textarea"
      spellcheck="false"
      contenteditable="true"
      :style="textareaStyle"
      :data-text="placeholder"
      @keyup="saveRangeSub('keyup')"
      @click="saveRangeSub('click')"
    ></div>
    <el-tooltip effect="dark" content="使用本流程节点对象的值" placement="bottom">
      <group-dropdown-menu :group-list="varGroup" @select="insertItem">
        <div class="tip-btn tip-icon">
          <i class="el-icon-plus"></i>
        </div>
      </group-dropdown-menu>
    </el-tooltip>
  </div>
</template>

<script>
import GroupDropdownMenu from "@/components/UIComponents/GroupDropdownMenu/GroupDropdownMenu"

export default {
  name: "textarea-editor",
  components: { GroupDropdownMenu },
  props: {
    value: {
      type: Object
      // default: () => ({
      //   text: "",
      //   arr: []
      // })
    },
    varGroup: Array,
    minHeight: {
      type: [String, Number],
      default: 30
    },
    maxHeight: {
      type: [String, Number],
      default: 120
    },
    outputTextType: {
      // 为 string 时，变量会被''包裹后拼接到字符串中；为 normal 时，变量直接拼接到字符串中
      type: String,
      default: "string"
    },
    placeholder: {
      type: String,
      default: "请输入"
    }
  },
  data() {
    return {
      rangeStart: null,
      isInitial: false,
      testStr: ""
    }
  },
  watch: {
    value: {
      handler() {
        let curValue = this.getOutput()
        if (!this._.isEqual(curValue, this.value)) {
          this.initialData(this.value?.arr || this.value?.outputTextArr || [])
        }
      }
    }
  },
  computed: {
    textareaDom() {
      return this.$refs.textarea
    },
    textareaStyle() {
      return {
        minHeight: this.minHeight + "px",
        maxHeight: this.maxHeight + "px"
      }
    }
  },
  mounted() {
    this.initialData(this.value?.arr || this.value?.outputTextArr || [])
  },
  methods: {
    initialData(textareaArr) {
      this.isInitial = true
      this.textareaDom.innerHTML = ""
      textareaArr.forEach(i => {
        if (i.type == "text") this.insertText(i.text)
        else if (i.type == "btn") this.insertItem(i)
      })
      this.isInitial = false
    },
    insertItem(item) {
      let editDiv = this.textareaDom
      if ("getSelection" in window) {
        let sel = window.getSelection()
        let div = document.createElement("div")
        // 初始化的innerHTML就是label
        if (this.isInitial) div.innerHTML = item.label
        // 非初始化的innerHTML需要拼接
        else div.innerHTML = item.label
        div.className = "btn"
        div.id = item.value
        if (!this.rangeStart) {
          this.rangeStart = document.createRange()
          this.rangeStart.selectNodeContents(editDiv)
          this.rangeStart.collapse(false)
          sel.removeAllRanges()
          sel.addRange(this.rangeStart)
        }
        this.rangeStart.insertNode(this.rangeStart.createContextualFragment("&nbsp;"))
        this.rangeStart.insertNode(div)
        this.rangeStart.collapse(false) // 对于IE来说，参数不可省略
        sel.removeAllRanges()
        sel.addRange(this.rangeStart)
        editDiv.focus()
      } else if ("selection" in document) {
        editDiv.focus()
        let range = document.selection.createRange()
        range.pasteHTML("<div id='" + item.value + "'>" + item.label + "</div>")
        editDiv.focus() // IE 11模拟的IE5~IE8无须这一步也能获得焦点
      }
      if (this.isInitial) editDiv.blur()
      if (!this.isInitial) this.output()
    },
    insertText(text) {
      let editDiv = this.textareaDom
      if ("getSelection" in window) {
        let sel = window.getSelection()
        if (!this.rangeStart) {
          this.rangeStart = document.createRange()
          this.rangeStart.selectNodeContents(editDiv)
          this.rangeStart.collapse(false)
          sel.removeAllRanges()
          sel.addRange(this.rangeStart)
        }
        let textNode = document.createTextNode(text)
        this.rangeStart.insertNode(textNode)
        this.rangeStart.collapse(false) // 对于IE来说，参数不可省略
        sel.removeAllRanges()
        sel.addRange(this.rangeStart)
      } else if ("selection" in document) {
        editDiv.focus()
        let range = document.selection.createRange()
        range.text = text
        editDiv.focus() // IE 11模拟的IE5~IE8无须这一步也能获得焦点
      }
      if (this.isInitial) editDiv.blur()
    },
    output() {
      this.$emit("input", this.getOutput())
    },
    saveRangeSub(from) {
      let selection = window.getSelection ? window.getSelection() : document.selection
      if (!selection.rangeCount) return
      this.rangeStart = selection.createRange ? selection.createRange() : selection.getRangeAt(0)
      if (from == "keyup") this.output()
    },
    getOutput() {
      switch (this.outputTextType) {
        case "string":
          return this.getOutputTextForString()
        case "normal": {
          return this.getOutputTextForNormal()
        }
      }
    },
    // 输出的变量不需要被''包裹，不同区块间直接连接
    getOutputTextForNormal() {
      let text = "",
        testStr = "",
        arr = []
      this.textareaDom.childNodes.forEach(node => {
        if (node.className == "btn") {
          text = text + "" + node.id.toString()
          testStr = testStr + "" + (Math.random() * 100).toFixed(5)
          arr.push({
            type: "btn",
            label: node.textContent.trim(),
            value: node.id.toString()
          })
        } else if (node.textContent.trim() != "") {
          text = text + "" + node.textContent.trim()
          testStr = testStr + "" + node.textContent.trim()
          arr.push({
            type: "text",
            text: node.textContent
          })
        }
      })
      this.testStr = testStr
      return { text, arr }
    },
    // 输出的变量要被''包裹，不同区块间直接用"+"连接
    getOutputTextForString() {
      let text = ""
      let arr = []
      this.textareaDom.childNodes.forEach(node => {
        if (node.className == "btn") {
          if (text == "") text = text + node.id.toString()
          else text = text + "+" + node.id.toString()
          arr.push({
            type: "btn",
            label: node.textContent.trim(),
            value: node.id.toString()
          })
        } else if (node.textContent == "\n" || node.textContent.trim() != "") {
          if (text == "") text = text + "'" + node.textContent + "'"
          else text = text + "+" + "'" + node.textContent.replace(/\n/g, "<br>") + "'"
          arr.push({
            type: "text",
            text: node.textContent
          })
        }
      })
      return { text, arr }
    },
    // 校验表达式
    verifyOutputStr() {
      try {
        let res = eval("(" + this.testStr + ")")
        if (isNaN(res) || !isFinite(res))
          return {
            result: false,
            msg: "默认值不合法，请修改"
          }
        return { result: true, msg: "" }
      } catch (e) {
        // console.log("错误：", e)
        return {
          result: false,
          msg: "默认值不合法，请修改"
        }
      }
    }
  }
}
</script>

<style lang="scss">
.textarea-editor {
  display: flex;
  position: relative;
  word-break: break-all;
  [contentEditable="true"]:empty:not(:focus):before {
    content: attr(data-text);
    color: #c4c4d0;
  }
  .textarea {
    flex: 1;
    line-height: 30px;
    min-height: 30px;
    max-height: 120px;
    margin-left: auto;
    margin-right: auto;
    padding: 4px 10px;
    border-radius: 4px 0 0 4px;
    border: 1px solid #dcdfe6;
    font-size: 14px;
    word-wrap: break-word;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-user-modify: read-write-plaintext-only;
    &:focus {
      border-color: #409eff;
      outline: none;
    }
    div {
      display: inline-flex;
      -webkit-user-modify: read-only;
      &:focus {
        outline: none;
      }
    }
    .btn {
      line-height: 24px;
      padding: 0 10px;
      margin: 2px 5px;
      background-color: #01ca83;
      color: #fff;
      border-radius: 14px;
      border: 1px solid #9cd7f1;
    }
  }
  .tip-btn {
    cursor: pointer;
    width: 40px;
    min-width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    border-style: solid;
    border-color: #ddd;
    box-sizing: border-box;
    border-width: 1px 1px 1px 0;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    color: #9e9e9e;
  }
}
</style>
